import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=53b2d50c&scoped=true&"
import script from "./Sobre.vue?vue&type=script&lang=js&"
export * from "./Sobre.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=53b2d50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2d50c",
  null
  
)

export default component.exports